import { paymentsApi, type PaymentsApi } from '../api/payments'
import { analytics } from '../lib/analytics'
import type { PaymentChannel, PlanId, StoreProduct } from './types'

export class TochkaPaymentChannel implements PaymentChannel {
  readonly provider = 'tochka' as const

  constructor(
    private readonly api: Pick<PaymentsApi, 'plans' | 'createLink'> = paymentsApi,
    private readonly redirect: (url: string) => void = (url) => window.location.assign(url),
  ) {}

  async getProducts(): Promise<StoreProduct[]> {
    const response = await this.api.plans()
    return response.plans.flatMap((plan) => plan.price == null ? [] : [{
      planId: plan.id as PlanId,
      productId: plan.id,
      productType: plan.recurring ? 'SUBSCRIPTION' as const : 'CONSUMABLE_PRODUCT' as const,
      title: plan.name,
      formattedPrice: `${plan.price} ₽`,
      price: plan.price,
      currency: 'RUB',
      subscriptionPeriods: [],
    }])
  }

  async purchase(planId: PlanId) {
    const response = await this.api.createLink(planId)
    if (!response.payment_url) throw new Error('payment_link_unavailable')
    this.redirect(response.payment_url)
    analytics.track('paymentOpened', { planId })
    return { status: 'completed' as const, planId }
  }

  async manageSubscription(): Promise<void> {
    throw new Error('manage_subscription_unavailable')
  }
}
